import { Component } from '@wordpress/element';
import App, { AppContext } from '../App';
import { ResultArticle, ResultDeal } from './';
// import ReactPaginate from 'react-paginate';

interface GridProps {

}

interface selectedItem {
    selected: number
}


export class ResultGrid extends Component<GridProps> {
    currentPage: number;
    eventAttached = false;
    loadMore: HTMLElement;
    stopScrollEvents = false;
    totalPages: number;

    renderContent = ( app: App ) => {
        const { post_type } = app.props.wpProps;
        const { results, total_pages, current_page, stopScrollEvents, searching } = app.state;

        if (this.stopScrollEvents !== stopScrollEvents) this.stopScrollEvents = stopScrollEvents;
        if (this.currentPage !== current_page) this.currentPage = current_page;
        if (this.totalPages !== total_pages) this.totalPages = total_pages;

        // const onPageChange = (item: selectedItem) => {
        //     app.setState({current_page: item.selected + 1}, app.query);
        // }

        const loadMore = () => {
            this.stopScrollEvents = true;
            app.setState({current_page: this.currentPage + 1, stopScrollEvents: true}, app.query);
        }

        const maybeLoadMore = () => {
            if (!this.loadMore) return;
            if (!!this.stopScrollEvents) return;
            const pastMidway = (this.loadMore.getBoundingClientRect().top - window.innerHeight / 2) < 0;
            if (pastMidway && this.currentPage < this.totalPages) {
                loadMore();
            }
        }

        if (!this.eventAttached) {
            maybeLoadMore();
            window.addEventListener('scroll', maybeLoadMore);
            this.eventAttached = true;
        }

        return (
            <div className="search__results">
                {results.length > 0 ? <div className="layout__med-col-12">
                    {
                        post_type == 'article' ?
                        <div>
                            {results.map(result => <ResultArticle result={result}/>)}
                        </div> :
                        <div className="deal-card-grid">
                            {results.map(result => <ResultDeal result={result} placeholder={app.props.wpProps.placeholder_deal_image}/>)}
                        </div>
                    }
                    {total_pages > 1 && current_page < total_pages && <div id="load-more" ref={ref => this.loadMore = ref}>
                        <button className="btn--load-more" onClick={loadMore} disabled={searching}>{searching ? 'Loading...' : 'Load More'}</button>
                    </div>}

                    {/* <ReactPaginate
                        key={current_page}
                        pageCount={total_pages}
                        pageRangeDisplayed={2}
                        marginPagesDisplayed={1}
                        containerClassName="search__paginate"
                        initialPage={current_page - 1}
                        onPageChange={onPageChange}
                    /> */}

                </div> :
                <div className="layout__med-col-12">
                    <p className="search__message search__message--no-results">
                        There are no results for your search. Try a different keyword or broaden your search criteria.
                    </p>
                </div>}
            </div>
        )
    }

    render() {
        return (
            <AppContext.Consumer>
                {this.renderContent}
            </AppContext.Consumer>
        )
    }
}
